/**
 * Разбор события `WhatsAppSenderQR`, которое CRM шлёт при смене состояния
 * WhatsApp-интеграции (issue/11029).
 *
 * Токен приходит внутри `jsonData` — JSON-сериализованной строки. Фронт
 * исторически читал поле `param1`, которого в контракте нет: для существующей
 * интеграции сравнение всегда было ложным, а при двух отсутствующих значениях
 * превращалось в `undefined === undefined` и закрывало окно от события чужого
 * аккаунта организации.
 */

export interface WhatsAppSenderQrEnvelope {
  isSuccess?: boolean;
  jsonData?: string | null;
  data?: string | null;
}

export interface WhatsAppSenderQrEvent {
  isSuccess: boolean;
  /** Токен инстанса или null, если событие пришло без него. */
  token: string | null;
}

const readToken = (raw: string | null | undefined): string | null => {
  if (typeof raw !== 'string') return null;

  const trimmed = raw.trim();
  if (!trimmed) return null;

  // jsonData — строка, сериализованная как JSON: обычно это строка в кавычках,
  // но встречается и голое значение.
  try {
    const parsed: unknown = JSON.parse(trimmed);

    if (typeof parsed === 'string') {
      return parsed.trim() || null;
    }

    return null;
  } catch {
    return trimmed;
  }
};

export const parseWhatsAppSenderQrEvent = (
  payload: unknown
): WhatsAppSenderQrEvent => {
  if (!payload || typeof payload !== 'object') {
    return { isSuccess: false, token: null };
  }

  const envelope = payload as WhatsAppSenderQrEnvelope;

  return {
    isSuccess: Boolean(envelope.isSuccess),
    token: readToken(envelope.jsonData) ?? readToken(envelope.data),
  };
};

/**
 * Событие относится к нашей сессии. Отсутствие любой из сторон совпадением НЕ
 * считается: иначе окно закрывается от чужого аккаунта.
 */
export const isEventForToken = (
  eventToken: string | null,
  expectedToken: string | null
): boolean =>
  Boolean(eventToken && expectedToken && eventToken === expectedToken);
